<template>
  <div class="c-dashboard__card">
    <b-card :title="$t('lang.label_certificate_byUsageType')" class="text-center">
      <bar-chart :style="styles" :chart-data="barChartData" :options="barChartOptions" />
    </b-card>
  </div>
</template>
<script>
import BarChart from "../BarChart";
export default {
  name: "CertificatesByUsageTypeChart",
  props: {
    statistics: {}
  },
  data() {
    const _this = this;
    return {
      barChartOptions: {
        hoverBorderWidth: 20,
        responsive: true,
        onClick: function(evt, array) {
          var position = array[0]._index;
          var label = this.tooltip._data.labels[position];
          _this.goToSearch(label);
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? "pointer" : "default";
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                stepSize: 2
              }
            }
          ]
        }
      },
      backgroundColor: ["#79BE75", "#976EA2", "#F3E05D"],

      //customization of bar size
      barPercentage: 0.5,
      barThickness: 60,
      maxBarThickness: 70,
      minBarLength: 1,

      //customize height and weight
      styles: {
        width: "100%",
        height: "300px"
      }
    };
  },
  components: {
    BarChart
  },
  computed: {
    barChartData() {
      const chartData = {};
      const certUsageType = this.$props.statistics.data.certUsageType;
      //build labels and data in seperate array
      const labels = [];
      const data = [];
      Object.keys(certUsageType).forEach(key => {
        labels.push(this.$t("lang.enum_keyUsageType_" + key));
        data.push(certUsageType[key]);
      });

      let datasets = {};
      //datasets bar properties
      datasets.backgroundColor = this.backgroundColor;
      datasets.barPercentage = this.barPercentage;
      datasets.barThickness = this.barThickness;
      datasets.maxBarThickness = this.maxBarThickness;
      datasets.minBarLength = this.minBarLength;

      //datasets data
      datasets.data = data;

      chartData.datasets = [];
      //labels
      chartData.labels = labels;
      //chart data
      chartData.datasets.push(datasets);
      return chartData;
    }
  },
  methods: {
    goToSearch(value) {
      const searchFilter = {
        certUsageType: [value
          .replace(" ", "_")
          .replace("/", "")
          .toUpperCase()]
      };
      this.$store.commit("certificate/addFromGraph_columnsVisible", "certUsageType");
      this.$store.commit("certificate/resetAndUpdate_searchFilter", searchFilter);
      this.$router.push({ name: "certificates", params: { isFromChart: true } });
    }
  }
};
</script>
